//SERVICES
import ServiceMovement from "../../services/Movement";

//TYPES
export const START_GET_MOVEMENT = "START_GET_MOVEMENT";
export const SUCCESS_GET_MOVEMENT = "  SUCCESS_GET_MOVEMENT";
export const ERROR_GET_MOVEMENT = "  ERROR_GET_MOVEMENT";

export function getListMovementAction(userId) {
  return async dispatch => {
    dispatch({ type: START_GET_MOVEMENT });

    return new Promise((resolve, reject) => {
      ServiceMovement.INSTANCE.getListMovement(userId)
        .then(listProvince => {
          dispatch({
            type: SUCCESS_GET_MOVEMENT
          });
          resolve(listProvince);
        })
        .catch(error => {
          dispatch({ type: ERROR_GET_MOVEMENT });
          reject(error);
        });
    });
  };
}

